var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16",
    fill: "#fff",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32v-2C8.268 30 2 23.732 2 16h-4c0 9.941 8.059 18 18 18zm16-16h-2c0 7.732-6.268 14-14 14v4c9.941 0 18-8.059 18-18zM16 0v2c7.732 0 14 6.268 14 14h4c0-9.941-8.059-18-18-18zm0 0v-2C6.059-2-2 6.059-2 16h4C2 8.268 8.268 2 16 2z",
    fill: "#8dc63f",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUnchecked);
export default __webpack_public_path__ + "static/media/radio-unchecked.41bc17d217180c5f1bd6706bd50b5fd2.svg";
export { ForwardRef as ReactComponent };